import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGALSITEPLAN,
  DELETE_LEGALSITEPLAN,
  UPDATE_LEGALSITEPLAN,
  ADD_NEW_LEGALSITEPLAN,
} from "./actionType";

import {
  getLegalSiteplanSuccess,
  getLegalSiteplanFail,
  deleteLegalSiteplanSuccess,
  deleteLegalSiteplanFail,
  updateLegalSiteplanSuccess,
  updateLegalSiteplanFail,
  addLegalSiteplanSuccess,
  addLegalSiteplanFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLegalSiteplanApi,
  updateLegalSiteplanApi,
  deleteLegalSiteplanApi,
  addNewLegalSiteplanApi
} from "../../helpers/backend_helper";

function* getLegalSiteplan({ payload: legalSiteplan }) {
  try {
    const response = yield call(getLegalSiteplanApi, legalSiteplan);
    yield put(getLegalSiteplanSuccess(GET_LEGALSITEPLAN, response.data));
  } catch (error) {
    yield put(getLegalSiteplanFail(GET_LEGALSITEPLAN, error));
  }
}

function* onUpdateLegalSiteplan({ payload: legalSiteplan }) {
  try {
    const response = yield call(updateLegalSiteplanApi, legalSiteplan);
    yield put(updateLegalSiteplanSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateLegalSiteplanFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegalSiteplan({ payload: legalSiteplan }) {
  try {
    const response = yield call(deleteLegalSiteplanApi, legalSiteplan);
    yield put(deleteLegalSiteplanSuccess({ legalSiteplan, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalSiteplanFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegalSiteplan({ payload: legalSiteplan }) {
  try {
    const response = yield call(addNewLegalSiteplanApi, legalSiteplan);
    yield put(addLegalSiteplanSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalSiteplanFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegalSiteplan() {
  yield takeEvery(GET_LEGALSITEPLAN, getLegalSiteplan);
}

export function* watchUpdateLegalSiteplan() {
  yield takeEvery(UPDATE_LEGALSITEPLAN, onUpdateLegalSiteplan);
}

export function* watchDeleteLegalSiteplan() {
  yield takeEvery(DELETE_LEGALSITEPLAN, onDeleteLegalSiteplan);
}

export function* watchAddNewLegalSiteplan() {
  yield takeEvery(ADD_NEW_LEGALSITEPLAN, onAddNewLegalSiteplan);
}

function* legalSiteplanSaga() {
  yield all([
    fork(watchGetLegalSiteplan),
    fork(watchDeleteLegalSiteplan),
    fork(watchUpdateLegalSiteplan),
    fork(watchAddNewLegalSiteplan)
  ]);
}

export default legalSiteplanSaga;
